// used when deployed to marzen and when using install_to_android.bat
export const environment = {
    production: true,
    backendHost: 'https://phonee.ceenergy.hu',
    backendURL: 'https://phonee.ceenergy.hu/phonee/rest',
};
